// controllers/window-size-controller.ts
import { BreakPoint, windowSize } from "@adornis/base/client/frontend-helpers/window-size.js";
import "@lit/reactive-element";
import { debounceTime, map, shareReplay, startWith } from "rxjs";
import "./chemistry-controller.js";
var getDevice = (width, breakPoints) => {
  if (width < breakPoints[BreakPoint.smallPhone])
    return BreakPoint.smallPhone;
  if (width < breakPoints[BreakPoint.phone])
    return BreakPoint.phone;
  if (width < breakPoints[BreakPoint.bigPhone])
    return BreakPoint.bigPhone;
  if (width < breakPoints[BreakPoint.tablet])
    return BreakPoint.tablet;
  if (width < breakPoints[BreakPoint.laptop])
    return BreakPoint.laptop;
  if (width < breakPoints[BreakPoint.desktopSmall])
    return BreakPoint.desktopSmall;
  if (width < breakPoints[BreakPoint.huge])
    return BreakPoint.huge;
  return BreakPoint.smallPhone;
};
var WindowSizeController = class _WindowSizeController {
  constructor(host, { debounceTime: time = 25, triggerUpdates = true } = {}) {
    this.host = host;
    this._triggerUpdates = triggerUpdates;
    _WindowSizeController.observable ??= windowSize.pipe(
      debounceTime(100),
      startWith({
        width: window.innerWidth,
        height: window.innerHeight,
        device: getDevice(window.innerWidth, this.host.sizes.breakPoints)
      }),
      map((size) => {
        const device = getDevice(size.width, this.host.sizes.breakPoints);
        return {
          height: size.height,
          width: size.width,
          device,
          tablet: device <= BreakPoint.tablet,
          mobile: device <= BreakPoint.bigPhone,
          mobileSmall: device <= BreakPoint.smallPhone,
          landscape: size.height < size.width
        };
      }),
      shareReplay(1)
    );
    this.observable = _WindowSizeController.observable.pipe(debounceTime(time));
    this.host.addController(this);
  }
  hostConnected() {
    this._subscription?.unsubscribe();
    this._subscription = this.observable.subscribe((size) => {
      this.value = size;
      this.width = size.width;
      this.height = size.height;
      this.device = size.device;
      this.tablet = size.tablet;
      this.mobile = size.mobile;
      this.mobileSmall = size.mobileSmall;
      this.landscape = size.landscape;
      if (this._triggerUpdates)
        this.host.requestUpdate();
    });
  }
  hostDisconnected() {
    this._subscription?.unsubscribe();
  }
};
export {
  WindowSizeController,
  getDevice
};
